// Select all elements with class "rte"
const rtes = Array.from(document.querySelectorAll(".rte"));

// Generally a safe min width
const minCellWidth = 145;

// Loop through each "rte" element
rtes.forEach((rte) => {
  // Select tables only within the current "rte" element
  const tables = Array.from(rte.querySelectorAll("table"));

  // Loop through each table within the current "rte" element
  tables.forEach((t) => {
    // Create a div wrapper
    const divWrapper = document.createElement("div");
    divWrapper.className = "overflow-table";

    // Insert the div wrapper before the table
    t.parentNode.insertBefore(divWrapper, t);

    // Move the table inside the div wrapper
    divWrapper.appendChild(t);

    // Calculate the total number of columns
    let columns = 0;
    const firstRow = t.querySelector("tr");
    const cells = firstRow.querySelectorAll("td, th");

    cells.forEach((cell) => {
      const colspan = cell.getAttribute("colspan");
      columns += colspan ? parseInt(colspan) : 1;
    });

    // Set the minimum width for the table
    t.style.minWidth = columns * minCellWidth + "px";
  });
});
